import React from 'react'
import styled from 'styled-components'
import Chip from '@ntuctech/devex-tangram/Chip'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import SvgFilter from '@ntuctech/devex-tangram/Icon/SvgFilter'
import SvgArrowDown from '@ntuctech/devex-tangram/Icon/SvgArrowDown'
import {
  Modal,
  ModalContent,
  ModalTitle,
  Checkbox,
  Link,
  Typography,
} from '@ntuctech/devex-tangram'
import { SCREEN_SIZE } from '../../lib/Media'

const StyledEverydayBody = styled.div`
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 0.25rem;
  svg {
    width: 1rem;
    height: 1rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    padding: 2rem 2rem 0;
    position: relative;
  }

  ${SCREEN_SIZE.From.Desktop} {
    border-radius: 0.25rem;
    margin-top: -1.5rem;
    padding: 2.5rem 2.5rem 0;
    position: relative;
  }
`

const StyledHeaderText = styled.div`
  padding: 0.25rem;
  font-weight: 700;
  font-size: 1.438rem;
  line-height: 2rem;
  color: #0d2618;
`

const StyledBodyContent = styled.div`
  padding: 0.25rem;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #333333;
`

const StyledFilterContainer = styled.div`
  margin-top: 1.5rem;
`

const StyledCheckBox = styled(Checkbox)`
  margin: 1rem 0.5rem 0 0;
`

const StyledFilterSelection = styled.div`
  margin: 0 1rem 0 0;
`

const StyledTyphography = styled(Typography)`
  display: flex;
  align-items: end;
`

const StyledModalTitle = styled.div`
  display: block;
  text-align: center !important;
`

const StyledLink = styled.div`
  margin-top: 1.25rem;
  display: flex;
  align-items: end;
  svg {
    margin-right: 0.5rem;
  }
`

const EverydaySaveBody = ({ contents, filterList }) => {
  const {
    pageTitle,
    pageDescription,
    campaignPeriod,
    howToRedeem,
    howToRedeemUrl,
  } = contents
  const [open, setOpen] = React.useState(false)
  const isFilterEnable = false

  const RenderFilterModal = () => {
    return (
      <NdsThemeProvider>
        <Modal open={open}>
          <ModalTitle>
            <StyledModalTitle>
              <Typography variant="h6">Filter</Typography>
            </StyledModalTitle>
          </ModalTitle>
          <ModalContent>
            <Typography variant="h6">Category</Typography>
            {filterList['categories']?.slice(0, 5).map((content, i) => (
              <StyledFilterSelection key={i}>
                <StyledTyphography variant="body3">
                  <StyledCheckBox />
                  {content.name}
                </StyledTyphography>
              </StyledFilterSelection>
            ))}
            <StyledLink>
              <SvgArrowDown size="s" color="#1454B8" />
              <Link>View All</Link>
            </StyledLink>
          </ModalContent>
        </Modal>
      </NdsThemeProvider>
    )
  }

  return (
    <>
      <StyledEverydayBody>
        {isFilterEnable && RenderFilterModal()}
        <StyledHeaderText>{pageTitle}</StyledHeaderText>
        <StyledBodyContent>{pageDescription}</StyledBodyContent>
        {howToRedeem && howToRedeemUrl && (
          <Link
            size="m"
            href={howToRedeemUrl}
            data-testid="how-to-redeem-link"
            className="how-to-redeem"
            style={{ marginLeft: '0.25rem' }}
          >
            {howToRedeem}
          </Link>
        )}
        <StyledBodyContent>{campaignPeriod}</StyledBodyContent>
        {isFilterEnable && (
          <StyledFilterContainer>
            <NdsThemeProvider>
              <Chip
                onClick={() => setOpen(true)}
                variant="filter"
                icon={<SvgFilter />}
                label="Filter"
              />
              <Chip variant="filter" icon={<SvgArrowDown />} label="Category" />
              <Chip variant="filter" icon={<SvgArrowDown />} label="Brand" />
            </NdsThemeProvider>
          </StyledFilterContainer>
        )}
      </StyledEverydayBody>
    </>
  )
}

export default EverydaySaveBody
